import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Upload } from "lucide-react";
import { toast } from "sonner";

// Sube un archivo (imagen o PDF) al endpoint /upload del servidor y devuelve su URL.
// IMPORTANTE: 'folder' debe ir ANTES de 'file' para que multer lo reciba en destination.
export async function uploadPnFile(file: File): Promise<string> {
  const fd = new FormData();
  fd.append("folder", "design_pn");
  fd.append("file", file);
  const res = await fetch("/upload", { method: "POST", body: fd });
  if (!res.ok) throw new Error("Error al subir el archivo al servidor");
  const j = await res.json();
  return j.url as string;
}

interface Props {
  onUploaded: (url: string) => void;
  label?: string;
  size?: "sm" | "default";
  variant?: "outline" | "ghost" | "secondary" | "default";
}

export function PnPhotoUpload({ onUploaded, label = "Subir imagen/PDF", size = "default", variant = "outline" }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await uploadPnFile(file);
      onUploaded(url);
      toast.success("Archivo subido");
    } catch (err: any) {
      toast.error(err.message || "Error al subir el archivo");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.gif,.webp,.pdf" className="hidden" onChange={onPick} />
      <Button type="button" size={size} variant={variant} disabled={busy} onClick={() => inputRef.current?.click()} className="gap-2">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}{label}
      </Button>
    </>
  );
}
